import { Component, OnInit, Inject, Input } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ReportsService } from 'src/app/services/reports.service';

// import * as jspdf from 'jspdf';
// import html2canvas from 'html2canvas';

@Component({
  selector: 'app-showdistrictwisestatusreport',
  templateUrl: './showdistrictwisestatusreport.component.html',
  styleUrls: ['./showdistrictwisestatusreport.component.scss']
})
export class ShowDistrictWiseStatusReportComponent implements OnInit {
  routeParams: any;
  reportUrl: any;
  submitbtn: string;
  title: string;

  @Input()
  url: SafeResourceUrl;
  src: string;
  pdfSource: any;
  src1: any;
  loading = true;

  constructor(
    private reportService: ReportsService,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ShowDistrictWiseStatusReportComponent>,
    public sanitizer: DomSanitizer
  ) {
  }

  ngOnInit() {
    this.data.downloadType = 4;
    this.reportService.tripreport(this.data).subscribe(result => {
      if (result) {
        // this.pdfSource = result;
        //  const dt = this.sanitizer.bypassSecurityTrustResourceUrl('data:application/pdf;base64,' + result + '#toolbar=1&navpanes=0');
        // this.src = 'data:text/html;base64,' + result;
        // setTimeout(() => {
        //   this.src = 'data:text/html;base64,' + result;
        // }, 1000);
        const decodedStringAtoB = atob(result);
        this.src1 = this.sanitizer.bypassSecurityTrustHtml(decodedStringAtoB);
        this.loading = false;
        // this.src = decodedStringAtoB;
      }
    });
  }

  // downloadpdf() {
  //   // this.generatePDF();
  //   // const linkSource = 'data:text/html;base64, ' + this.pdfSource;
  //   const linkSource = 'data:application/pdf;base64, ' + this.pdfSource;
  //   const downloadLink = document.createElement('a');
  //   const fileName = 'tripreport.pdf';
  //   // const fileName = 'tripreport.html';

  //   downloadLink.href = linkSource;
  //   downloadLink.download = fileName;
  //   downloadLink.click();
  // }

  downloadpdf() {
    const pdfdata = this.data;
    pdfdata.downloadType = 1;
    this.reportService.tripreport(pdfdata).subscribe(result => {
      if (result) {
        this.pdfSource = result;
        const linkSource = 'data:application/pdf;base64, ' + result;
        const downloadLink = document.createElement('a');
        const fileName = this.data.reportType== 63 ?'PACCS District Machinary Report.pdf':this.data.reportType== 62 ?'PACCS Block Machinary Report.pdf': this.data.ReportType== 60 ?'PACCS Implemet Report.pdf':this.data.ReportType== 41 ?'Booking Details And Pendency Report.pdf':this.data.ReportType== 44 ?'Block Wise Status Report.pdf':this.data.ReportType == 46 ?'Block Wise Machinery Status Report.pdf' :this.data.reportType == 47 ?'District Wise Implement Added Report.pdf':this.data.reportType == 50?'Service Provider Status Report.pdf':this.data.ReportType == 52 ?'Service Provider Registration Private Report.pdf':this.data.ReportType == 53 ?'Service Provider Registration Paccs Report.pdf':this.data.reportType == 54? 'District WiseMachinery Added Report.pdf' :'District Wise Status Report.pdf';
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      }
    });
  }

  downloadexcel() {
    const printdata = this.data;
    printdata.downloadType = 2;
    this.reportService.tripreport(printdata).subscribe(result => {
      if (result) {
        const linkSource = 'data:application/vnd.ms-excel;base64, ' + result;
        const downloadLink = document.createElement('a');
        const fileName =this.data.reportType== 63 ?'PACCS District Machinary Report.xls': this.data.reportType== 62 ?'PACCS Block Machinary Report.xls':this.data.ReportType== 60 ?'PACCS Implemet Report.xls': this.data.ReportType==12 || this.data.ReportType == 40?'District Wise Status Report.xls':this.data.ReportType== 41 ?'Booking Details And Pendency Report.xls':this.data.ReportType== 44 ?'Block Wise Status Report.xls':this.data.ReportType == 46 ?'Block Wise Machinery Status Report.xls' :this.data.reportType == 47 ?'District Wise Implement Added Report.xls':this.data.reportType == 50?'Service Provider Status Report.xls':this.data.ReportType == 52 ?'Service Provider Registration Private Report.xls' :this.data.ReportType == 53 ?'Service Provider Registration Paccs Report.xls':this.data.reportType == 54 ? (this.data.ServiceProviderType == 4 ? 'PACCS with District.xls' : this.data.ServiceProviderType == 5 ? 'Private with District.xls' : 'District WiseMachinery Added Report.xls') :'District Wise Subsidy  Review Report.xls';
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      }
    });
  }

  downloadhtml() {
    const printdata = this.data;
    printdata.downloadType = 4;
    this.reportService.tripreport(printdata).subscribe(result => {
      if (result) {
        const linkSource = 'data:text/html;base64, ' + result;
        const downloadLink = document.createElement('a');
        const fileName =this.data.reportType== 63 ?'PACCS District Machinary Report.html':this.data.reportType== 62 ?'PACCS Block Machinary Report.html':this.data.ReportType== 60 ?'PACCS Implemet Report.html': this.data.ReportType==12 || this.data.ReportType == 40?'District Wise Status Report.html':this.data.ReportType== 44 ?'Block Wise Status Report.html':this.data.ReportType== 41 ?'Booking Details And Pendency Report.html':this.data.ReportType == 46 ?'Block Wise Machinery Status Report.html' :this.data.reportType == 47 ?'District Wise Implement Added Report.html':this.data.reportType == 50?'Service Provider Status Report.html':this.data.ReportType == 52 ?'Service Provider Registration Private Report.html' :this.data.ReportType == 53 ?'Service Provider Registration Paccs Report.html':this.data.reportType == 54? 'District WiseMachinery Added Report.html' :'District Wise Subsidy  Review Report.html';
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      }
    });
  }

  downloadword() {
    const worddata = this.data;
    worddata.downloadType = 3;
    this.reportService.tripreport(worddata).subscribe(result => {
      if (result) {
        const linkSource = 'data:application/msword;base64, ' + result;
        const downloadLink = document.createElement('a');
        const fileName =this.data.reportType== 63 ?'PACCS District Machinary Report.doc':this.data.reportType== 62 ?'PACCS Block Machinary Report.doc': this.data.ReportType== 60 ?'PACCS Implemet Report.doc': this.data.ReportType==12 || this.data.ReportType == 40 ?'District Wise Status Report.doc' :this.data.ReportType== 41 ?'Booking Details And Pendency Report.doc':this.data.ReportType== 44 ?'Block Wise Status Report.doc':this.data.ReportType == 46 ?'Block Wise Machinery Status Report.doc' :this.data.reportType == 47 ?'District Wise Implement Added Report.doc':this.data.reportType == 50?'Service Provider Status Report.doc':this.data.ReportType == 52 ?'Service Provider Registration Private Report.doc' :this.data.ReportType == 53 ?'Service Provider Registration Paccs Report.doc':this.data.reportType == 54? 'District WiseMachinery Added Report.doc' : 'District Wise Subsidy  Review Report.doc';
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      }
    });
  }

  print() {
    const exceldata = this.data;
    exceldata.downloadType = 1;
    this.reportService.tripreport(exceldata).subscribe(result => {
      if (result) {
        this.printPreview(result);
      }
    });
  }

  printPreview = (data, type = 'application/pdf') => {
    let blob = null;
    blob = this.b64toBlob(data, type);
    const blobURL = URL.createObjectURL(blob);
    const theWindow = window.open(blobURL);
    const theDoc = theWindow.document;
    const theScript = document.createElement('script');
    function injectThis() {
      window.print();
    }
    theScript.innerHTML = `window.onload = ${injectThis.toString()};`;
    theDoc.body.appendChild(theScript);
  };

  b64toBlob = (content, contentType) => {
    contentType = contentType || '';
    const sliceSize = 512;
    // method which converts base64 to binary
    const byteCharacters = window.atob(content);

    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, {
      type: contentType
    }); // statement which creates the blob
    return blob;
  };

  onCancel() {
    this.dialogRef.close();
  }

  close(isProceed) {
    this.dialogRef.close(isProceed);
  }

}
